/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ViewingsInputs */

const cs_nav_viewings = /** @type {(inputs: Nav_ViewingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídky`)
};

const en_nav_viewings = /** @type {(inputs: Nav_ViewingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewings`)
};

/**
* | output |
* | --- |
* | "Viewings" |
*
* @param {Nav_ViewingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_viewings = /** @type {((inputs?: Nav_ViewingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ViewingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_viewings(inputs)
	return cs_nav_viewings(inputs)
});